import React from 'react';
import { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { GeneralRoute } from '../../utils/routes';

const MenuButton = () => {
	const { pathname } = useLocation();
	const [state, setState] = useState({
		showMenu: false,
	});
	return (
		<>
			<div
				className={`${
					state.showMenu ? 'hidden' : ''
				}fixed z-50 top-16 left-4 md:hidden`}
			>
				<div onClick={() => setState({ ...state, showMenu: true })}>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 24 24"
						strokeWidth="1.5"
						stroke="currentColor"
						className="w-8 h-8 bg-gray-400 rounded-sm"
					>
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
						/>
					</svg>
				</div>
			</div>
			{state.showMenu && (
				<div className="absolute top-0 left-0 right-0 pt-20 w-full z-50 flex flex-col min-h-full space-y-2 bg-white">
					<div
						className=""
						onClick={() => setState({ ...state, showMenu: false })}
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 24 24"
							strokeWidth={1.5}
							stroke="currentColor"
							className="w-8 h-8 ml-3 -mt-4"
						>
							<path
								strokeLinecap="round"
								strokeLinejoin="round"
								d="M6 18L18 6M6 6l12 12"
							/>
						</svg>
					</div>

					<div className="h-full w-full flex flex-col">
						{GeneralRoute.map((val) => (
							<div key={val.label} className="my-2 pl-5 pr-5">
								<h4 className="font-bold mb-2 text-blue text-lg">
									{val.label}
								</h4>
								{val.content.map((route) => (
									<div
										key={route.path}
										className={
											pathname === route.path
												? 'border-2 border-gray bg-gray-50 p-2 rounded-md'
												: ' p-2'
										}
										onClick={() => setState({ ...state, showMenu: false })}
									>
										<NavLink to={route.path}>
											<h4 className="text-sm">{route.name}</h4>
										</NavLink>
									</div>
								))}
							</div>
						))}
					</div>
				</div>
			)}
		</>
	);
};

export default MenuButton;
